// removed by extract-text-webpack-plugin
module.exports = {"animationTime":"500ms"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rendering/slide.css
// module id = 634
// module chunks = 0